 <div class="mt-0 md:mt-2 bg-card rounded-2xl shadow">
    <div class="overflow-y-auto overflow-x-auto p-4">
        <table
            class="w-full bg-transparent mb-2"
            mat-table
            matSort
            [dataSource]="dataSource?.data"
            #bienes>

            <!-- imagen favorita -->
            <ng-container matColumnDef="imagen">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    Imagen
                </th>
                <td mat-cell *matCellDef="let bien">
                    <img [src]="bien?.blobURL?? '/assets/images/img-placeholder.jpg'" alt="" class="w-8 h-8 object-fil flex-shrink-0 m-2 rounded-full shadow-sm bg-gray-100">
                </td>
            </ng-container>

            <!-- No. Registro -->
            <ng-container matColumnDef="no-registro">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    No. Registro
                </th>
                <td mat-cell *matCellDef="let bien">
                    <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                        {{ bien.bienCultural.noRegistro }}
                    </span>
                </td>
            </ng-container>

            <!-- Nombre -->
            <ng-container matColumnDef="nombre">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    Nombre
                </th>
                <td mat-cell *matCellDef="let bien">
                    <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                        {{ bien.bienCultural.titulo }}
                    </span>
                </td>
            </ng-container>

            <!-- Propietario -->
            <ng-container matColumnDef="propietario">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    Propietario
                </th>
                <td mat-cell *matCellDef="let bien">
                    <span class="whitespace-nowrap pr-6 text-sm text-secondary font-medium">
                        {{ bien.bienCultural.propietario }}
                    </span>
                </td>
            </ng-container>

            <!-- Sección -->
            <ng-container matColumnDef="seccion">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                    Sección
                </th>
                <td mat-cell *matCellDef="let bien">

                    <status-sticker [estado]="bien.bienCultural.seccion.descripcion" [color1]="bien.bienCultural.seccion?.valor1" [color2]="bien.bienCultural.seccion?.valor2"></status-sticker>   

                </td>
            </ng-container>

            <!-- Categoría-->
            <ng-container matColumnDef="categoria">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 text-nowrap">
                    Categoría
                </th>
                <td mat-cell *matCellDef="let bien">
                     <status-sticker [estado]="bien.bienCultural.tipoBien.descripcion" [color1]="bien.bienCultural.tipoBien.valor1" [color2]="bien.bienCultural.tipoBien?.valor2"></status-sticker>
                </td>
            </ng-container>

            <!-- Registrado Por-->
            <ng-container matColumnDef="registrado-por">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 text-nowrap">
                    Registrado Por
                </th>
                <td mat-cell *matCellDef="let bien">
                    <div  class="flex gap-1">
                    
                        <user-avatar-name [name]="bien.bienCultural.fichaRegistroPor.nombreCompleto"></user-avatar-name>
                        
                    </div>
                </td>
            </ng-container>

            <!--  Fecha de Ingreso -->
            <ng-container matColumnDef="fecha-modificacion">
                <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1 text-nowrap">
                    Fecha de Ingreso
                </th>
                <td mat-cell *matCellDef="let bien">
                    <span class="whitespace-nowrap text-sm ">
                        {{ bien.bienCultural.fechaFichaRegistro  | date: 'mediumDate' }}
                    </span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="gestionesTableColumns" class="bg-slate-100 h-12"></tr>
            <tr class="text-gray-600 order-row h-10 border-y border-gray-200 cursor-pointer hover:text-black" 
                (click)="openTaskDetails(row.bienCultural.bienCulturalUuid)"
            mat-row *matRowDef="let row; columns: gestionesTableColumns;"></tr>
        </table>
         <mat-paginator [length]="totalResultItems" [pageSize]="this.pageSize" [hidePageSize]="true"></mat-paginator>
    </div> 
 </div>
       
